import { Line } from '../../../Common/Charts/Line';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';

export const PopulationBalance = () => {
    const { chartData } = useGeneralResultsChartsDataContext();

    return (
        <Line
            title={'Saldo Populacional (Nascidos Vivos x Óbitos)'}
            subtitles={chartData?.populationBalance?.map((item) => item.description)}
            values={chartData?.populationBalance?.map((item) => item.total || 0)}  
            category='Estatisticas Vitais'
        />
    );
};
